"use client";

import { ComponentProps, PropsWithChildren } from "react";
import { Flex as RadixFlex } from "@radix-ui/themes";
import { useIsShopsite } from "@context/DomainContext";
import { joinClassNames } from "@utils/helpers";
interface Props {
  className?: string;
  sharedClasses?: string;
  shopsiteClasses?: string;
  whitelabelClasses?: string;
}

export default function Flex({
  className = "",
  sharedClasses = "",
  shopsiteClasses = "",
  whitelabelClasses = "",
  direction,
  align,
  justify,
  gap,
  children,
  ref,
  ...restProps
}: ComponentProps<typeof RadixFlex> & PropsWithChildren<Props>) {
  const isShopsite = useIsShopsite();

  const dir =
    direction === "column"
      ? "flex-col"
      : direction === "column-reverse"
      ? "flex-col-reverse"
      : direction === "row-reverse"
      ? "flex-row-reverse"
      : direction === "row"
      ? "flex-row"
      : "";
  const shopsiteBaseClasses = joinClassNames(
    "flex",
    dir,
    gap ? `gap-${gap}` : "",
    align ? `items-${align}` : "",
    justify ? `justify-${justify}` : ""
  );

  if (isShopsite) {
    return (
      <div
        ref={ref}
        className={joinClassNames(
          shopsiteBaseClasses,
          className,
          sharedClasses,
          shopsiteClasses
        )}
        {...restProps}
      >
        {children}
      </div>
    );
  }

  return (
    <RadixFlex
      ref={ref}
      direction={direction}
      gap={gap}
      align={align}
      justify={justify}
      {...restProps}
      className={joinClassNames(className, sharedClasses, whitelabelClasses)}
    >
      {children}
    </RadixFlex>
  );
}
